<template>
    <!-- eslint-disable vue/no-unused-vars -->
    <div class="vr-panel">
        <MainLeftPanel @eventHandle="leftPanelEvent" :selectedKey="selectNavKey" :listNavMenu="listNavMenu" class="leftpanel"></MainLeftPanel>
        <div class="vright v-full vh-flex">
            <div class="vtopbar">
                <div class="vc-flex dwm1">
                    <div class="vc-flex">
                        <svg-icon fill="var(--ek-text-color2)" svgname="ic_menu3" :size="20"></svg-icon>
                        <span class="mgl5 curmenuname">{{ selectNavName }}</span>
                    </div>
                </div>
                <div class="vc-flex">
                    <icon-menu @click="openBuyPage" svgname="ic_pro" name="普通用户" space="2px" :iconSize="16"
                        color="var(--ek-text-color2)"></icon-menu>

                    <ThemeSwitchView style="margin-left: 30px;"></ThemeSwitchView>

                    <div @click="exitLogin" class="themediv focus-s">
                        <svg-icon fill="var(--ek-text-color2)" svgname="ic_exit2" :size="14"></svg-icon>
                    </div>
                </div>
            </div>
            <div class="vcontent vh-full vh-flex card-shadow">
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>

            </div>
        </div>
        <!-- 确认对话框 -->
        <ConfirmDialog :showDialog="confirmDialog.show" :title="confirmDialog.title" :message="confirmDialog.message"
            @selectButton="confirmDialog.callBack"></ConfirmDialog>
    </div>
</template>

<script>
/* global LightApp */
import SvgIcon from '@/components/SvgIcon.vue';
import IconMenu from '@/components/IconMenu.vue';
import MainLeftPanel from '@/pages/main/views/MainLeftPanel.vue';
import ThemeSwitchView from '@/components/ThemeSwitchView.vue';
import eventBus from '@/commom/event/EventBus';
import localUser from '@/commom/local/LocalUser';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';

export default {
    name: 'MainPage',
    components: {
        IconMenu,
        SvgIcon,
        MainLeftPanel,
        ThemeSwitchView,
        ConfirmDialog

    },
    props: {

    },
    data() {
        return {
            themeKey: "",
            selectNavKey: "my-book-list",
            selectNavName: "我的课程库",
            confirmDialog: {
                show: false,
                title: "删除",
                message: "确认删除该课程包吗？",
                callBack: null
            },
            listNavMenu: [
                { name: "我的主页", key: "user-home-page", icon: "ic_home", iconSize: 16 },
                { name: "我的课程库", key: "my-book-list", icon: "ic_book", iconSize: 16 },
                { name: "在线课程库", key: "online-store", icon: "ic_store", iconSize: 16 },
                { name: "我的生词本", key: "new-word-page", icon: "ic_scbook", iconSize: 16 },
                { name: "推荐分成计划", key: "my-share-page", icon: "ic_present", iconSize: 16 },
                //{ name: "偏好设置", key: "app-setting", icon: "ic_basic_setting", iconSize: 16 }
            ]
        }
    },
    // 挂载完成
    mounted: function () {

        // 根据当前路由更新导航选择状态
        this.updateNavSelectionByRoute()
        this.listenEvent()

    },
    // 监听路由变化
    watch: {
        '$route'(to) {
            this.updateNavSelectionByRoute()
        }
    },
    methods: {
        ///监听事件
        listenEvent: function () {
            const that = this
            eventBus.on("mainPageEvent", function (dt) {
                switch (dt.name) {
                    case "gotoStore":
                        that.leftMenuClick(that.listNavMenu.find(p => p.key == "online-store"))
                        break
                    case "gotoBookList":
                        that.leftMenuClick(that.listNavMenu.find(p => p.key == "my-book-list"))
                        break
                }
            })
        },
        ///左侧菜单事件
        leftPanelEvent: function (ev) {
            switch (ev.name) {
                case "menuClick":
                    this.leftMenuClick(ev.data)
                    break;
            }
        },
        ///左侧菜单点击
        leftMenuClick: function (item) {
            this.selectNavKey = item.key
            this.selectNavName = item.name
            this.$router.push(`/${item.key}`)
        },
        ///打开购买会员页面
        openBuyPage: function () {
            this.selectNavKey = ""
            this.selectNavName = "升级VIP会员"
            this.$router.push("/buy-member-page")
        },
        ///根据当前路由更新导航选择状态
        updateNavSelectionByRoute: function () {
            const currentPath = this.$route.path.replace('/', '')
            const menuItem = this.listNavMenu.find(item => item.key === currentPath)
            if (menuItem) {
                this.selectNavKey = menuItem.key
                this.selectNavName = menuItem.name
            }
        },
        ///退出登录
        exitLogin: function () {
            var that = this
            that.confirmDialog.show = true
            that.confirmDialog.title = "退出"
            that.confirmDialog.message = "确认要退出登录吗？"
            that.confirmDialog.callBack = function (result) {
                if (!result) {
                    that.confirmDialog.show = false
                    return
                }
                localUser.clearCacheUser()
                that.$router.replace("/login-page")
            }
        }


    }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.curmenuname{
    font-size: 14px;
    color: var(--ek-text-color2);
}
.dwm1 {
    padding-left: 5px;
    font-size: 15px;
    color: var(--ek-text-color2);
}

.themediv {
    background: var(--ek-card-color2);
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    height: 28px;
    border-radius: 20px;
    margin-left: 15px;
    align-items: center;
}

.vtopbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
    padding-bottom: 5px;
    height: 45px;
}

.vcontent {
    background: var(--ek-mainbody-bgcolor);
    border-radius: 10px;
    margin-left: 5px;
    margin-right: 20px;
    margin-bottom: 20px;
}



/* 定义 fade 过渡的状态 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>